export const ADD_RIDER_BENEFIT = 'ADD_RIDER_BENEFIT'

export const UPDATE_RIDER_BENEFIT = 'UPDATE_RIDER_BENEFIT'

export const REMOVE_RIDER_BENEFIT = 'REMOVE_RIDER_BENEFIT'

export const UPDATE_POLICY_VALUE = 'UPDATE_POLICY_VALUE'

export const UPDATE_BENEFIT_SUMMARY = 'UPDATE_BENEFIT_SUMMARY'

export const UPDATE_TAX_DEDUCTION = 'UPDATE_TAX_DEDUCTION'

export const addRiderBenefit = (riderBenefitKey, riderBenefitData) => ({
  type: ADD_RIDER_BENEFIT,
  payload: { riderBenefitKey, riderBenefitData },
})

export const updateRiderBenefit = (riderBenefitKey, riderBenefitData) => ({
  type: UPDATE_RIDER_BENEFIT,
  payload: { riderBenefitKey, riderBenefitData },
})

export const removeRiderBenefit = (riderBenefitKey) => ({
  type: REMOVE_RIDER_BENEFIT,
  payload: { riderBenefitKey },
})

export const updatePolicyValue = (policyValue) => ({
  type: UPDATE_POLICY_VALUE,
  payload: policyValue,
})

export const updateBenefitSummary = (benefitSummary) => ({
  type: UPDATE_BENEFIT_SUMMARY,
  payload: benefitSummary,
})

export const updateTaxDeduction = (taxDeduction) => ({
  type: UPDATE_TAX_DEDUCTION,
  payload: taxDeduction,
})
